/**
 * Geometry shared by the Day and Week time-grid views.
 *
 * These three values were duplicated in DayView and WeekView, and they drifted:
 * WeekView named its floor `MIN_EVENT_PX` and passed the matching minute value
 * to the overlap packer, while DayView hard-coded the same `22` inline and
 * passed nothing — so short back-to-back meetings packed side by side in Week
 * view and still overlapped in Day view. One definition, both views.
 */

/** Height of one hour row, in pixels. Both views scroll on this scale. */
export const PX_PER_HOUR = 48

/**
 * Smallest card height, so a short meeting still fits its title.
 *
 * A 10-minute meeting is only ~8px tall at PX_PER_HOUR, so its card is drawn
 * taller than its duration. That extra height is what spills onto the meeting
 * booked straight after it.
 */
export const MIN_EVENT_PX = 22

/**
 * MIN_EVENT_PX expressed in minutes, for `layoutOverlappingEvents`.
 *
 * The packer decides overlap in minutes and knows nothing about pixels, so a
 * view that floors card height MUST tell it the same floor — otherwise the
 * packer sees no overlap and gives both events the full column width, and they
 * are then drawn on top of each other.
 */
export const MIN_EVENT_MINUTES = MIN_EVENT_PX / (PX_PER_HOUR / 60)
